import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Translate, withLocalize } from 'react-localize-redux';
import { isNullOrUndefined, openInNewWindow } from '../../store/storeFunctions';

import WarningIcon from '../../img/icons/BBiconsVi';

import './refButtons.scss';

class WarningsButton extends React.Component {
    static propTypes = {
        key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        hideLabel: PropTypes.bool,
        link: PropTypes.string
    };

    static defaultProps = {
        key: undefined,
        hideLabel: false,
        link: undefined
    };

    render() {
        return (
            <div className="ref-button ref-warnings" title={this.props.translate('Report.Warnings.SectionName')}
                onClick={isNullOrUndefined(this.props.link) ? undefined : () => openInNewWindow(this.props.link, this.props.translate("Report.Warnings.SectionName"))}
            >
                <WarningIcon className='search-result-icon svg-ni-fill' />
                {this.renderLabel()}
            </div>
        );
    }

    renderLabel = () => {
        if (this.props.hideLabel)
            return null;

        return (
            <span className={classnames('link-internal', {'is-normal': localStorage.locales_url_format === 'normal', 'hide-on-mobile': !this.props.showOnMobile})}>
                <Translate id="Report.Warnings.SectionName" />
            </span>
        );
    }
}

export default withLocalize(WarningsButton);